import { useMemo } from 'react';
import { useSpotMarkets } from './useSpotMarkets';
import { SpotMarketConfig } from '@drift-labs/sdk';

export const useSpotMarketsLookup = (): SpotMarketConfig[] => {
	const spotMarkets = useSpotMarkets();

	return useMemo(() => {
		const maxSpotMarketIndex = Math.max(
			...spotMarkets.map((market) => market.marketIndex)
		);

		const lookup = new Array(maxSpotMarketIndex > 0 ? maxSpotMarketIndex : 1);

		spotMarkets.forEach((market) => {
			lookup[market.marketIndex] = market;
		});

		return lookup;
	}, [spotMarkets]);
};
